import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import React from "react";

export const getCoachCount = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getDBWithInit } = await import("~/lib/db");
    const { coaches } = await import("~/../drizzle/schema");
    const { count, isNotNull } = await import("drizzle-orm");

    const [result] = await (
      await getDBWithInit()
    )
      .select({ count: count() })
      .from(coaches)
      .where(isNotNull(coaches.approvedAt));

    return result.count;
  },
);

export const Route = createFileRoute("/embed/number-of-coaches/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ["coachCount"],
      queryFn: () => getCoachCount(),
    });
    return {};
  },
  component: CoachCountPage,
});

function CoachCountPage() {
  const { data: coachCount } = useQuery({
    queryKey: ["coachCount"],
    queryFn: () => getCoachCount(),
  });

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="font-heading text-[min(40vw,40vh)] tabular-nums">
        {coachCount}
      </div>
    </div>
  );
}
